export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10311.b3a9a1fc.jpg";